export default __webpack_public_path__ + "static/media/@jualineferraz.be5aa6e8.jpg";